import type { TransformFunctionStatement } from '../types/transform-script';
import { parse } from './generated/parser.js';

interface PeggySyntaxError extends Error {
  location?: {
    start: {
      line: number;
      column: number;
    };
  };
}

/**
 * Experimental Peggy implementation of the transform-script parser.
 *
 * Production code intentionally continues to use transform-script/core.ts
 * until this implementation has full compatibility coverage.
 */
export function parseTransformScript(code: string): TransformFunctionStatement[] {
  try {
    return parse(code) as TransformFunctionStatement[];
  } catch (error) {
    const syntaxError = error as PeggySyntaxError;
    const start = syntaxError.location?.start;
    const position = start ? `line ${start.line}:${Math.max(0, start.column - 1)} ` : '';
    throw new Error(`transform script parse error: ${position}${syntaxError.message}`);
  }
}
